export default { sha: '793fe5794b59a9fc1274ade5caafd96a2300f36b', buildNumber: 'undefined' }
